// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._typography-module__dsAccented--FmMXO,._typography-module__dsAccented--FmMXO *{font-weight:500}._typography-module__dsDefaultWeight--zdT5p,._typography-module__dsDefaultWeight--zdT5p *{font-weight:400}h5._typography-module__dsAccented--FmMXO,h5._typography-module__dsAccented--FmMXO *{font-weight:700}._typography-module__dsUnderline--UdLdm,._typography-module__dsUnderline--UdLdm *{text-decoration:underline}._typography-module__dsAccented2--cZkFf,._typography-module__dsAccented2--cZkFf *{font-weight:700}._typography-module__dsBodyXL--ueXM0,._typography-module__dsBodyXL--ueXM0 *{font-size:18px;line-height:27px}._typography-module__dsBodyLarge--VSTop,._typography-module__dsBodyLarge--VSTop *{font-size:16px;line-height:24px}._typography-module__dsBody--Ct69T,._typography-module__dsBody--Ct69T *{font-size:14px;line-height:20px}._typography-module__dsBodySmall--M6EBV,._typography-module__dsBodySmall--M6EBV *{font-size:12px;line-height:18px}._typography-module__dsBodyXS--CgxrR,._typography-module__dsBodyXS--CgxrR *{font-size:10px;line-height:15px}._typography-module__dsActionLarge--Pg6qi,._typography-module__dsActionLarge--Pg6qi *{font-size:16px;line-height:18px}._typography-module__dsAction--VUc5C,._typography-module__dsAction--VUc5C *{font-size:14px;line-height:16px}._typography-module__dsActionSmall--yMWxN,._typography-module__dsActionSmall--yMWxN *{font-size:12px;line-height:14px}._typography-module__dsColumnHeadLine--EQptF,._typography-module__dsColumnHeadLine--EQptF *{font-size:12px;line-height:18px;font-weight:500;text-transform:uppercase}._typography-module__dsLightXL--uRRzD,._typography-module__dsLightXL--uRRzD *{font-size:120px;line-height:160px;font-weight:300}._typography-module__dsLightLarge--XjnFq,._typography-module__dsLightLarge--XjnFq *{font-size:48px;line-height:64px;font-weight:300}._typography-module__dsLight--ldGhF,._typography-module__dsLight--ldGhF *{font-size:32px;line-height:64px;font-weight:300}._typography-module__dsLightSmall--MgtmR,._typography-module__dsLightSmall--MgtmR *{font-size:24px;line-height:36px;font-weight:300}._typography-module__dsLightXS--HQUhh,._typography-module__dsLightXS--HQUhh *{font-size:18px;line-height:27px;font-weight:300}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dsH1FontSize": `32px`,
	"dsH1LineHeight": `48px`,
	"dsH2FontSize": `26px`,
	"dsH2LineHeight": `39px`,
	"dsH3FontSize": `22px`,
	"dsH3LineHeight": `33px`,
	"dsH4FontSize": `18px`,
	"dsH4LineHeight": `27px`,
	"dsH5FontSize": `16px`,
	"dsH5LineHeight": `24px`,
	"dsH6FontSize": `14px`,
	"dsH6LineHeight": `20px`,
	"dsBodyXLFontSize": `18px`,
	"dsBodyXLLineHeight": `27px`,
	"dsBodyLargeFontSize": `16px`,
	"dsBodyLargeLineHeight": `24px`,
	"dsBodyFontSize": `14px`,
	"dsBodyLineHeight": `20px`,
	"dsBodySmallFontSize": `12px`,
	"dsBodySmallLineHeight": `18px`,
	"dsBodyXSFontSize": `10px`,
	"dsBodyXSLineHeight": `15px`,
	"dsActionLargeSize": `16px`,
	"dsActionLargeLineHeight": `18px`,
	"dsActionSize": `14px`,
	"dsActionLineHeight": `16px`,
	"dsActionSmallSize": `12px`,
	"dsActionSmallLineHeight": `14px`,
	"dsColumnHeadFontSize": `12px`,
	"dsColumnHeadLineHeight": `18px`,
	"dsLightXLFontSize": `120px`,
	"dsLightXLLineHeight": `160px`,
	"dsLightLargeFontSize": `48px`,
	"dsLightLargeLineHeight": `64px`,
	"dsLightFontSize": `32px`,
	"dsLightLineHeight": `64px`,
	"dsLightSmallFontSize": `24px`,
	"dsLightSmallLineHeight": `36px`,
	"dsLightXSFontSize": `18px`,
	"dsLightXSLineHeight": `27px`,
	"dsAccented": `_typography-module__dsAccented--FmMXO`,
	"dsDefaultWeight": `_typography-module__dsDefaultWeight--zdT5p`,
	"dsUnderline": `_typography-module__dsUnderline--UdLdm`,
	"dsAccented2": `_typography-module__dsAccented2--cZkFf`,
	"dsBodyXL": `_typography-module__dsBodyXL--ueXM0`,
	"dsBodyLarge": `_typography-module__dsBodyLarge--VSTop`,
	"dsBody": `_typography-module__dsBody--Ct69T`,
	"dsBodySmall": `_typography-module__dsBodySmall--M6EBV`,
	"dsBodyXS": `_typography-module__dsBodyXS--CgxrR`,
	"dsActionLarge": `_typography-module__dsActionLarge--Pg6qi`,
	"dsAction": `_typography-module__dsAction--VUc5C`,
	"dsActionSmall": `_typography-module__dsActionSmall--yMWxN`,
	"dsColumnHeadLine": `_typography-module__dsColumnHeadLine--EQptF`,
	"dsLightXL": `_typography-module__dsLightXL--uRRzD`,
	"dsLightLarge": `_typography-module__dsLightLarge--XjnFq`,
	"dsLight": `_typography-module__dsLight--ldGhF`,
	"dsLightSmall": `_typography-module__dsLightSmall--MgtmR`,
	"dsLightXS": `_typography-module__dsLightXS--HQUhh`
};
module.exports = ___CSS_LOADER_EXPORT___;
